import { useEffect } from 'react';
import L from 'leaflet';
import { Satellite, MapPinPlus, MapPinned, Route } from 'lucide-react';
import { useGnss, gnssLive, subscribeGnss, FIX_COLORS, FIX_SHORT, openGnss } from '../lib/gnss';
import { fmtAcc } from './GnssDialog';

export function GnssChip({ t }) {
  const s = useGnss();
  const fix = s.fix || 'none';
  return (
    <button className={`chip gnss-chip ${s.connected ? 'on' : ''}`} data-testid="gnss-chip" title={t.gnssTitle} onClick={openGnss}>
      <Satellite size={14} />
      {s.connected
        ? <span data-testid="gnss-live-badge"><i className="gnss-dot" style={{ background: FIX_COLORS[fix] }} />{FIX_SHORT[fix]} · {s.sats ?? '–'} Sat · ±{fmtAcc(s.hrms)}</span>
        : t.gnssBtn}
    </button>
  );
}

export function GnssPlaceBar({ t, onPlace, hidden }) {
  const s = useGnss();
  if (hidden || !gnssLive(s)) return null;
  return (
    <div className="gnss-place-bar" data-testid="gnss-place-bar">
      <button className="btn btn-accent btn-sm" data-testid="gnss-place-fit-btn" onClick={() => onPlace('fit')}><MapPinPlus size={14} /> {t.gnssPlaceFit}</button>
      <button className="btn btn-primary btn-sm" data-testid="gnss-place-rep-btn" onClick={() => onPlace('rep')}><MapPinned size={14} /> {t.gnssPlaceRep}</button>
      <button className="btn btn-dark btn-sm" data-testid="gnss-line-start-btn" onClick={() => onPlace('line')}><Route size={14} /> {t.glStart}</button>
    </div>
  );
}

// live receiver position + accuracy circle
export function useGnssMarker(mapRef) {
  useEffect(() => {
    let dot = null, ring = null;
    const draw = (s) => {
      const map = mapRef.current;
      if (!map) return;
      if (!s.connected || s.lat == null) { dot?.remove(); ring?.remove(); dot = ring = null; return; }
      const c = FIX_COLORS[s.fix || 'none'], ll = [s.lat, s.lon];
      if (!dot) {
        ring = L.circle(ll, { radius: 1, color: c, weight: 1, fillOpacity: 0.15, interactive: false }).addTo(map);
        dot = L.circleMarker(ll, { radius: 7, color: '#fff', weight: 2, fillColor: c, fillOpacity: 1, interactive: false }).addTo(map);
      }
      dot.setLatLng(ll).setStyle({ fillColor: c });
      ring.setLatLng(ll).setRadius(Math.max(s.hrms || 0.05, 0.05)).setStyle({ color: c });
    };
    const un = subscribeGnss(draw);
    return () => { un(); dot?.remove(); ring?.remove(); };
  }, [mapRef]);
}
